import en from './en';
import es from './es';

const messages = {
    ...en,
    ...es,
};

export default messages;
